import { RootState } from '@data/store';
import { Store } from '@reduxjs/toolkit';

export let store: Store<RootState>;

export const injectBugsnagStore = (_store: Store<RootState>) => {
  store = _store;
};
